var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddRowAbove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18.5708H16V12.5708H2V18.5708ZM18 20.5708H0V2.5708H4V4.5708H2V10.5708H16V4.5708H14V2.5708H18V20.5708ZM8 6.5708V4.5708H6V2.5708H8V0.570801H10V2.5708H12V4.5708H10V6.5708H8Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddRowAbove);
export default __webpack_public_path__ + "static/media/add_row_above.14c77ccae5db2732c74ae55cb82724c0.svg";
export { ForwardRef as ReactComponent };